export default __webpack_public_path__ + "static/media/Snail.3b3ffb03.png";